var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-component'),_c('sale-info'),_c('discounts-surchages'),_c('hr'),_c('articles-search'),_c('articles-table'),_c('descriptions'),_c('options'),_c('btn-guardar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }